import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'

import styles from './standard_edit_part.less'

import EditPart from 'components/edit_part'
import ExpandableParagraph from 'components/common/expandable_paragraph'

class StandardEditPart extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    value: PropTypes.string,
    maxRows: PropTypes.number,
    lightTitle: PropTypes.bool,
    description: PropTypes.string,
    disabled: PropTypes.bool,
  }

  render() {
    let { title, value, lightTitle, maxRows, ...propsToTransfer } = this.props
    delete propsToTransfer.styles

    if (!propsToTransfer.editButtonDisplay) {
      propsToTransfer.editButtonDisplay = this.props.description
        ? 'bottom-no-margin'
        : 'right'
    }

    return (
      <EditPart {...propsToTransfer} labelName={this.props.title}>
        <div styleName={lightTitle ? 'title-light' : 'title'}>{title}</div>
        {maxRows ? (
          <ExpandableParagraph maxRows={maxRows} lightLink={true}>
            {value}
          </ExpandableParagraph>
        ) : (
          <div styleName="value">{value}</div>
        )}
        {this.props.description && (
          <div styleName="description">{this.props.description}</div>
        )}
      </EditPart>
    )
  }
}

export default cssModules(StandardEditPart, styles)
